import classNames from 'classnames'
import { Fragment, useMemo } from 'react'

import { Tooltip } from 'core-components/library/tooltip'

import { ROW_ACTIONS_FIELD } from '../constants/actions'
import styles from '../Table.module.scss'

import { IColumn, IRowAction } from './types'

export function Actions<P>(props: {
  item: P
  actions: IRowAction<P>[]
  keyField: string
  columns: IColumn[]
}) {
  const { actions, item, keyField, columns } = props
  const isRowActionsVisible = useMemo(() => {
    if (!actions?.length) {
      return false
    }

    const existedRowActions = columns.find((el) => el.field === ROW_ACTIONS_FIELD)
    if (!existedRowActions) {
      return true
    }
    return !existedRowActions.hidden
  }, [columns, actions])

  if (!isRowActionsVisible) {
    return <></>
  }

  return (
    <div className={styles.actionsOverlay}>
      {actions.map((action, index) => {
        const isVisible = action.isVisible ? action.isVisible(item) : true

        if (!isVisible) {
          return null
        }

        const { reason, isDisabled } = action.isDisabled
          ? action.isDisabled(item)
          : { isDisabled: false, reason: '' }

        if (action.customView) {
          return action.customView({ item, isDisabled, action: () => action.action(item) })
        }

        const defaultTextContent = action.title || ''
        const textContent = isDisabled ? reason || defaultTextContent : defaultTextContent

        return (
          <Fragment key={`action-${item[keyField]}-${index}`}>
            {action.icon ? (
              <Tooltip
                key={`action-${item[keyField]}-${index}-tooltip`}
                className={styles.actionsOverlay__tooltip}
                tipContent={() => <span>{textContent}</span>}
              >
                <button
                  data-testid={`table-action_${action.id}_${item[keyField]}`}
                  className={classNames(
                    styles.button,
                    styles['button--icon-btn'],
                    styles.actionsOverlay__button
                  )}
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (isDisabled) {
                      return
                    }
                    action.action(item)
                  }}
                  type={'button'}
                >
                  <i
                    className={classNames(
                      styles.button__icon,
                      typeof action.icon === 'function' ? action.icon(item) : action.icon
                    )}
                  />
                </button>
              </Tooltip>
            ) : (
              <button
                disabled={isDisabled}
                className={styles.button}
                onClick={(e) => {
                  e.stopPropagation()
                  if (isDisabled) {
                    return
                  }
                  action.action(item)
                }}
                type={'button'}
              >
                <span className={styles.button__text}>{textContent}</span>
              </button>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
